import css from '@styled-system/css';
import { useContext, useEffect, useState } from 'react';
import Box from '../../shared/layouts/Box';
import Stack from '../../shared/layouts/Stack';
import NotificationsWidget from './widgets/NotificationsWidget';
import UserContext from '../../../context/UserContext';
import Loader from '../../shared/Loader';
import ProcessSection from './widgets/ProcessWidget';
import { useTranslation } from 'react-i18next';
import ToolsWidget from './widgets/ToolsWidget';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import { Flex } from '../../shared/layouts';
import DashIcon from 'imagesUwKluis/svg/dual/dashboard.svg';
import Card from '../../shared/Card';
import CalendarWidget from './widgets/CalendarWidget';
import CalculationWidget from './widgets/CalculationWidget';
import ContactWidget from './widgets/ContactWidget';
import CalculationButton from '../calculations/components/CalculationButton';
import RequestWidget from "./widgets/RequestWidget";
import QuickActionsWidget from "./widgets/QuickActionsWidget";

export const DashHeading = ({ children }) => (
  <Box fontScale={'l'} fontWeight={'bold'} mt={0} mb={'m'}>
    {children}
  </Box>
);

const Dashboard = () => {
  const { user, enabledModules } = useContext(UserContext);
  const { isArgo, toolMaxMortgage, customMenuItems, finlyAppointments } = useContext(WhiteLabelContext);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isNotificationsLoading, setIsNotificationsLoading] = useState(true);
  const [isProcessesLoading, setIsProcessesLoading] = useState(!isArgo);
  const firstName = user?.first_name;

  useEffect(() => {
    if (!isNotificationsLoading && !isProcessesLoading) {
      setIsLoading(false);
    }
  }, [isNotificationsLoading, isProcessesLoading]);

  const Greeting = () => {
    const hours = new Date().getHours();
    if (hours < 6) return t('Goedenacht');
    if (hours < 12) return t('Goedemorgen');
    if (hours < 18) return t('Goedemiddag');
    return t('Goedenavond');
  };

  return (
    <>
      {isLoading && <Loader />}
      {isArgo ? (
        <>
          <Stack
            space="xl"
            fontScale={'l'}
            width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}
          >
            {/* Header */}
            <Flex justifyContent={'space-between'} alignItems={'center'}>
              <Box fontScale={'l'}>
                <Box fontScale={'xl'} fontWeight={'bold'}>
                  {t(`Hallo {{firstName}}`, { firstName })}
                </Box>
                <span>{t('hier vind je al je relevante informatie.')}</span>
              </Box>
              <DashIcon height={'96px'} />
            </Flex>
            {/* Widgets */}
            <RequestWidget />
            <Box>
              <DashHeading>{t('Laatste updates')}</DashHeading>
              <NotificationsWidget
                hideTitle
                setIsLoading={setIsNotificationsLoading}
              />
            </Box>
            {toolMaxMortgage && (
              <Box>
                <DashHeading>{t('Zelf rekenen')}</DashHeading>
                <CalculationWidget />
              </Box>
            )}
            {(enabledModules?.finly_client_connection && finlyAppointments) && (
              <Box>
                <DashHeading>{t('Je afspraken')}</DashHeading>
                <CalendarWidget />
              </Box>
            )}
            <ContactWidget />
            {customMenuItems?.length > 0 && (
              <Box>
                <DashHeading>{t('Handige links')}</DashHeading>
                <Card>
                  <Stack space={'s'}>
                    {customMenuItems.map(({ name, url }) => (
                      <a
                        key={url}
                        href={url}
                        target={'_blank'}
                        rel="noreferrer"
                      >
                        <CalculationButton name={name} />
                      </a>
                    ))}
                  </Stack>
                </Card>
              </Box>
            )}
          </Stack>
        </>
      ) : (
        <Stack space="m" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
          <Box fontScale="m" fontWeight="bold">
            <Greeting />
            {firstName && (
              <span css={css({ color: 'primary' })}>{` ${firstName}`}</span>
            )}
          </Box>
          <Stack space="xl">
            <ProcessSection setIsLoading={setIsProcessesLoading} />
            <NotificationsWidget setIsLoading={setIsNotificationsLoading} />
            <QuickActionsWidget />
            {toolMaxMortgage && <ToolsWidget />}
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default Dashboard;
